import Piou, { PiouStep } from "../Piou";
import Jump from "./Jump";
import { ActionType } from "./index";

export default abstract class Action {
  id: ActionType;
  piou: Piou;

  /*static*/ flExclu: boolean = false;
  /*static*/ flSameIsOk: boolean = false;

  protected constructor(id: ActionType, piou: Piou) {
    this.id = id;
    this.piou = piou;
    this.piou.currentAction = this;
  }

  init() {
    this.piou.initStep(PiouStep.ACTION);
  }

  update() {}

  interrupt() {
    this.piou.currentAction = null;
    this.piou.initWalk();
  }
}
